// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2bFK3","info_icon":"style_info_icon__CRKcY","info_block":"style_info_block__3WU6V","info_block__visable":"style_info_block__visable__2p-cS"};